var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { OfferDecoration } from "./OfferDecoration";
import { OfferDetails } from "./OfferDetails";
export var Offer = function (props) {
    var backgroundColor = props.backgroundColor;
    var tintStyle = {
        backgroundColor: backgroundColor,
        border: "none",
        height: "100%",
        width: "100%",
    };
    var headerStyle = {
        // Hiding header to preserve the height of the header for visual similarity
        visibility: "hidden",
    };
    return (React.createElement("div", { className: "offer-container" },
        React.createElement("div", { className: IdStyles.OfferHeader, style: headerStyle }),
        React.createElement("div", { className: IdStyles.OfferSlideshowBackground + " offer-body__container" },
            React.createElement("div", { className: IdStyles.OfferSlideshowBackground + " offer-container__tint", style: tintStyle }),
            React.createElement(OfferDecoration, __assign({}, props)),
            React.createElement(OfferDetails, __assign({}, props)))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/Offer.tsx
// module id = 2910
// module chunks = 3